import "./RootLayout.css";
import React, { useState, useEffect } from "react";

import { Layout, Menu, Button, theme, Row } from "antd";
import ProfileButton from "../../components/DropdownButtonProfile";
import SubMenu from "antd/es/menu/SubMenu";
import { NavLink, useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import routes from "../../utils/routes";
import {
  IoHome,
  IoPerson,
  IoPeople,
  IoNotificationsOutline,
  IoNotificationsCircle,
  IoSend,
  IoList,
  IoAdd,
  IoWallet,
  IoCard,
  IoMenu,
  IoChevronForward,
  IoStorefront,
  IoIdCard,
  IoBusiness,
  IoCheckmarkCircle,
  IoDocumentText,
  IoApps,
  IoGrid,
  IoAddCircle,
  IoBookmarks,
  IoFolder,
  IoReceiptOutline,
  IoStatsChart,
  IoImage,
} from "react-icons/io5";
// import packageJson from "../../../package.json";

const { Header, Sider, Content } = Layout;
const version = 0.1;

const RootLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  // Update selectedKeys based on current pathname
  const [selectedKeys, setSelectedKeys] = useState([location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Add this effect back to handle route changes
  useEffect(() => {
    setSelectedKeys([location.pathname]);
  }, [location.pathname]);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Layout className="layout">
      <Sider
        theme="light"
        width={270}
        trigger={null}
        collapsible
        collapsed={collapsed}
        className="sider">
        <Row>
          <Button
            type="link"
            icon={
              collapsed ? (
                <IoChevronForward className="menu-open-close-icon" />
              ) : (
                <IoMenu className="menu-open-close-icon" />
              )
            }
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "10px",
              width: 70,
              height: 32,
              color: "black",
            }}
          />
        </Row>

        <Menu
          theme="light"
          mode="inline"
          defaultSelectedKeys={[routes.home]}
          selectedKeys={selectedKeys}
          style={{
            borderRight: "none",
            marginBottom: "36px",
          }}>
          <Menu.Item
            key={routes.home}
            icon={<IoHome className="main-parent-icon" />}>
            <NavLink to={routes.home}>Anasayfa</NavLink>
          </Menu.Item>

          <SubMenu
            key="sub1"
            icon={<IoStorefront className="main-parent-icon" />}
            title="Dükkan Yönetimi">
            <Menu.Item key={routes.shops} icon={<IoBusiness />}>
              <NavLink to={routes.shops}>Dükkanlar</NavLink>
            </Menu.Item>
            <Menu.Item key={routes.invalidSubs} icon={<IoIdCard />}>
              <NavLink to={routes.invalidSubs}>
                Aksiyon Almamış Dükkanlar
              </NavLink>
            </Menu.Item>
            <Menu.Item key={routes.createShop} icon={<IoAdd />}>
              <NavLink to={routes.createShop}>Dükkan Ekle</NavLink>
            </Menu.Item>
          </SubMenu>
          <SubMenu
            key="sub2"
            icon={<IoPerson className="main-parent-icon" />}
            title="Müşteriler">
            <Menu.Item key={routes.clients} icon={<IoPeople />}>
              <NavLink to={routes.clients}>Müşteri Yönetimi</NavLink>
            </Menu.Item>

            <Menu.Item key={routes.createClient} icon={<IoAddCircle />}>
              <NavLink to={routes.createClient}>Müşteri Ekle</NavLink>
            </Menu.Item>
          </SubMenu>

          <Menu.Item
            key={routes.transactions}
            icon={<IoReceiptOutline className="main-parent-icon" />}>
            <NavLink to={routes.transactions}>Tüm İşlemler</NavLink>
          </Menu.Item>

          <SubMenu
            key="sub3"
            icon={<IoNotificationsOutline className="main-parent-icon" />}
            title="Bildirim Yönetimi">
            <Menu.Item
              key={routes.appNotifications}
              icon={<IoNotificationsCircle />}>
              <NavLink to={routes.appNotifications}>
                Uygulama Bildirimleri
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={routes.userNotifications}
              icon={<IoCheckmarkCircle />}>
              <NavLink to={routes.userNotifications}>
                Kullanıcı Bildirimleri
              </NavLink>
            </Menu.Item>
            <Menu.Item key={routes.sendNotification} icon={<IoSend />}>
              <NavLink to={routes.sendNotification}>Bildirim Gönder</NavLink>
            </Menu.Item>
          </SubMenu>

          <SubMenu
            key="sub4"
            icon={<IoApps className="main-parent-icon" />}
            title="Uygulama Yönetimi">
            <SubMenu
              key="sub4-1"
              icon={<IoDocumentText />}
              title="Uygulama Durumu">
              <Menu.Item key={routes.applicationStatuses} icon={<IoList />}>
                <NavLink to={routes.applicationStatuses}>
                  Uygulama Durumları
                </NavLink>
              </Menu.Item>
              <Menu.Item
                key={routes.createApplicationStatus}
                icon={<IoAddCircle />}>
                <NavLink to={routes.createApplicationStatus}>
                  Uygulama Durumu Ekle
                </NavLink>
              </Menu.Item>
            </SubMenu>
            <SubMenu key="sub4-2" icon={<IoFolder />} title="Uygulamalar">
              <Menu.Item key={routes.applications} icon={<IoGrid />}>
                <NavLink to={routes.applications}>Uygulamalar</NavLink>
              </Menu.Item>
              <Menu.Item key={routes.createApplication} icon={<IoAdd />}>
                <NavLink to={routes.createApplication}>Uygulama Ekle</NavLink>
              </Menu.Item>
            </SubMenu>
          </SubMenu>

          <SubMenu
            key="sub5"
            icon={<IoWallet className="main-parent-icon" />}
            title="Kart Yönetimi">
            <SubMenu key="sub5-1" icon={<IoCard />} title="Kartlar">
              <Menu.Item key={routes.otherCards} icon={<IoBookmarks />}>
                <NavLink to={routes.otherCards}>Kartlar</NavLink>
              </Menu.Item>
              <Menu.Item key={routes.createOtherCard} icon={<IoAddCircle />}>
                <NavLink to={routes.createOtherCard}>Kart Ekle</NavLink>
              </Menu.Item>
              <Menu.Item key={routes.otherCardUsage} icon={<IoStatsChart />}>
                <NavLink to={routes.otherCardUsage}>Kart Kullanımı</NavLink>
              </Menu.Item>
            </SubMenu>
            <SubMenu
              key="sub5-2"
              icon={<IoImage />}
              title="Kart Arka Plan Preset'leri">
              <Menu.Item
                key={routes.cardBackgroundPresets}
                icon={<IoBookmarks />}>
                <NavLink to={routes.cardBackgroundPresets}>Preset'ler</NavLink>
              </Menu.Item>
              <Menu.Item
                key={routes.createCardBackgroundPreset}
                icon={<IoAddCircle />}>
                <NavLink to={routes.createCardBackgroundPreset}>
                  Yeni Preset
                </NavLink>
              </Menu.Item>
            </SubMenu>
          </SubMenu>
        </Menu>

        {!collapsed && (
          <div
            style={{
              position: "absolute",
              bottom: 0,
              padding: "8px",
              fontSize: "10px",
              color: "#777777",
            }}>
            Version: {version}
            <br />
            <span>
              © 2024{" "}
              <a
                href="https://anemotech.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#0f1c9e", textDecoration: "none" }}>
                Anemo Technology
              </a>
              . All rights reserved.
            </span>
          </div>
        )}
      </Sider>
      <Layout className="layout">
        <Header
          className="header"
          style={{
            background: colorBgContainer,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: 22,
          }}>
          <div></div>
          Mahalle Kart Backoffice
          <div>
            <ProfileButton />
          </div>
        </Header>
        <Content
          className="content"
          style={{
            background: colorBgContainer,
            overflow: "auto",
          }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default RootLayout;
